// UserStatusBadge.js
import React from 'react';
import { Flex, Space } from 'antd';
import useAppStore from '../store';

const UserStatusBadge = ({ status, showStatus, font_size, show = false ,data}) => {
  const timeAgo = data?.lastActiveTime;

  const date = timeAgo;
  
  const display = date
    ? `${new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }).format(new Date(date))}` // ✅ Convert string to Date here
    : "Status unavailable";
  
  console.log(display);
  
    
  const statusConfig = {
    away: {
      badgeName: "Away",
      iconClass: "fa-solid fa-clock",
      color: "rgb(255, 212, 59)",
    },
    online: {
      badgeName: "Online",
      iconClass: "fa-solid fa-check-circle",
      color: "green",
    },
    do_not_disturb: {
      badgeName: "Do Not Disturb",
      iconClass: "fa-solid fa-circle-minus",
      color: "red",
    },
    offline: {
      badgeName: "Offline",
      iconClass: "fa-regular fa-circle",
      color: "grey",
    },
    busy: {
      badgeName: "Busy",
      iconClass: "fa-solid fa-circle-minus",
      color: "blue",
    }
  };

  // Default to offline if status is not recognized
  const { badgeName, iconClass, color } = statusConfig[status?.toLowerCase()] || statusConfig.offline;

  return (
    <>
      <Flex align='center' gap='4px' className="avatar-badge-status">
        <i className={ iconClass } style={ { color: color ?? "#FFD43B", fontSize: font_size } }></i>
        { timeAgo && badgeName == "Offline" && show ? ("Last online" + " " + display) : (showStatus && badgeName) }

      </Flex>
    </>
  );
};

export default UserStatusBadge;
